import _Object$assign from "babel-runtime/core-js/object/assign";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import org from "@/tools/org";
import tools from "./QS420_tools";
import GROUP_INFO from "./QS420_groupInfo.js";

import bizOrgOcr from "./bizOcrInfo/bizOrgOcr";
import bizZdInfoNode from "./bizZdInfo/bizZdInfoNode";
import bizOrgImportantInfoNode from "./bizOcrInfo/bizOrgImportantInfoNode";

import bizOrgOcrAgent from "./bizOcrInfo/bizOrgOcrAgent";
import bizOrgAgentBasicInfoNode from "./bizOcrInfo/bizOrgAgentBasicInfoNode";

import bizOrgBasicInfoNode from "./bizOrg/bizOrgBasicInfoNode";

import bizOtherLinkInfoNode from "./bizOther/bizOtherLinkInfoNode";
import bizOtherLegalInfoNode from "./bizOther/bizOtherLegalInfoNode";
import bizOtherAgentLinkInfoNode from "./bizOther/bizOtherAgentLinkInfoNode";
import bizOtherPartnerInfoNode from "./bizOther/bizOtherPartnerInfoNode";

import bizControlModuleInfoNode from "./bizControl/bizControlStockInfoNode";
import bizControlCustomModuleInfoNode from "./bizControl/bizControlInfoNode";
import bizControlBeneficiaryInfoNode from "./bizControl/bizBeneficiaryInfoNode";

import bizOtherCreditInfoNode from "./bizOther/bizOtherCreditInfoNode.js";
import bizTaxCustInfoNode from "./bizTaxInfo/bizTaxCustInfoNode";
import bizTaxContolInfoNode from "./bizTaxInfo/bizTaxContolInfoNode";

import bizTrdAcctInfoNode from "./bizAcct/bizTrdAcctInfoNode";
import bizAcctBsbInfoNode from "./bizAcct/bizAcctBsbInfoNode";
import bizAcctAssetInfoNode from "./bizAcct/bizAcctAssetInfoNode";

import bizAgentPhoneInfoNode from "./bizPassword/bizAgentPhoneInfoNode";
import bizPasswordInfoNode from "./bizPassword/bizPasswordInfoNode";
import { getCustAge } from "@/tools/util";
import smsService from "@/service/sms-service";
import oppService from "@/service/opp-service";

var NODE_LIST = [bizOrgOcr, bizOrgImportantInfoNode, bizZdInfoNode, bizOrgAgentBasicInfoNode, bizOrgOcrAgent, bizOrgBasicInfoNode, bizOtherLinkInfoNode, bizOtherLegalInfoNode, bizOtherAgentLinkInfoNode, bizOtherPartnerInfoNode, bizControlModuleInfoNode, bizControlCustomModuleInfoNode, bizControlBeneficiaryInfoNode, bizOtherCreditInfoNode, bizTaxCustInfoNode, bizTaxContolInfoNode, bizTrdAcctInfoNode, bizAcctBsbInfoNode, bizAcctAssetInfoNode, bizAgentPhoneInfoNode, bizPasswordInfoNode];
var isAllowOpenAcctSpecialOrg = function isAllowOpenAcctSpecialOrg(_this, params) {
  var subjectIdentityArr = ["6", "c"],
      customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
      subjectIdentity = customerInfo.SUBJECT_IDENTITY,
      szOrgTypeArr = ["10", "11", "12", "13", "14", "33", "34", "41", "99a", "99b"],
      szOrgType = _this.groupDatas[GROUP_INFO.ORG.GROUP_ID][GROUP_INFO.ORG.BASIC.MODULE_ID][0].FIELDS.SZORG_TYPE.DEFAULT_VALUE;
  return szOrgTypeArr.includes(szOrgType) || subjectIdentityArr.includes(subjectIdentity);
};
var getImgBusiData = function getImgBusiData(_this, params) {
  var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO),
      bsbInfo = _this.groupDatas[GROUP_INFO.ACCT.GROUP_ID][GROUP_INFO.ACCT.BSB_INFO.MODULE_ID][0].FIELDS,
      TRDACCT_INFO_LIST = _.get(params, "BIZ_DATA.TRDACCT_INFO_LIST", []),
      szStkpbuVal = "",
      shStkpbuVal = "",
      IS_NEED_COLLECT_Xbf = 0;

  if (_this.openAcctType != "3" && (customerInfo.CUST_FNAME != bsbInfo.BSB_USER_FNAME.DEFAULT_VALUE || customerInfo.ID_TYPE != bsbInfo.BSB_ID_TYPE.DEFAULT_VALUE || customerInfo.ID_CODE != bsbInfo.BSB_ID_CODE.DEFAULT_VALUE)) {
    IS_NEED_COLLECT_Xbf = "1";
  } else {
    IS_NEED_COLLECT_Xbf = "0";
  }
  var shTrdAcctArr = [],
      SH_ACCT = "",
      szTrdAcctArr = [],
      SZ_ACCT = "";
  TRDACCT_INFO_LIST.map(function (item) {
    if (["00", "01"].includes(item.STKBD)) {
      szStkpbuVal = item.STKPBU;
    } else {
      shStkpbuVal = item.STKPBU;
    }
    var trdAcct = item.TRDACCT;
    if (item.OP_TYPE == "$SZA") {
      szTrdAcctArr.push(trdAcct ? "深A-" + trdAcct : "深A账户新开");
      SZ_ACCT = trdAcct ? trdAcct : "新开";
    }
    if (item.OP_TYPE == "$SHA") {
      shTrdAcctArr.push(trdAcct ? "沪A-" + trdAcct : "沪A账户新开");
      SH_ACCT = trdAcct ? trdAcct : "新开";
    }
  });

  var isSpecialOrg = _.includes("10,11,12,13,14,15,33,34,41,51,52,99a,99b", _.get(params, "BIZ_DATA.BASE_INFO.SZORG_TYPE")) ? "1" : "0";
  var checkTrdacctObj = _.get(params, "DETAIL_DATA.checkTrdacctObj", []);

  var imgObj = {
    HAS_CONTRACT14: "",
    EXT_ORG: _this.groupDatas[GROUP_INFO.ACCT.GROUP_ID][GROUP_INFO.ACCT.ASSET_INFO.MODULE_ID][0].FIELDS.NEW_EXT_ORG.DEFAULT_VALUE || _.get(params, "IMG_DATA.EXT_ORG"),
    CUBSB_TRD_TYPE: "1",

    IS_OPEN_A: _.isEmpty(_.filter(checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && (key == "_11" || key == "_21");
    })) ? "0" : "1",

    IS_NEED_COLLECT_Xbf: IS_NEED_COLLECT_Xbf,

    IS_NEW_TRDACCT: _.isEmpty(_.filter(checkTrdacctObj, function (value, key) {
      return value.hasSave == "1" && value.SEL_TYPE == "1";
    })) ? "0" : "1",

    SH_ACCT_TEXT: shTrdAcctArr.join(","),
    SZ_ACCT_TEXT: szTrdAcctArr.join(","),
    NATIONAL_ATTR: _this.groupDatas[GROUP_INFO.ORG.GROUP_ID][GROUP_INFO.ORG.BASIC.MODULE_ID][0].FIELDS.NATIONAL_ATTR.DEFAULT_VALUE || _.get(params, "IMG_DATA.NATIONAL_ATTR"),

    NEED_SYNC_CUST: _.get(params, "DETAIL_DATA.NEED_SYNC_CUST", "") || _.get(params, "IMG_DATA.NEED_SYNC_CUST"),

    IS_SIGN_CONTRACT: "0",
    PROPER_CHECK_WITNESS_VIDEO: "",
    NEED_X41_IMG: "",
    IS_CSDC_REALNAME_ACCOUNT: _.get(params, "DETAIL_DATA.IS_CSDC_REALNAME_ACCOUNT", "0") || _.get(params, "IMG_DATA.IS_CSDC_REALNAME_ACCOUNT"),

    IS_SPECIAL_ORG: isSpecialOrg || _.get(params, "BIZ_DATA.isAllowOpenAcctSpecialOrg", "") || _.get(params, "IMG_DATA.IS_SPECIAL_ORG"),

    HAS_CORP_QUAL: _this.groupDatas[GROUP_INFO.ORG.GROUP_ID][GROUP_INFO.ORG.BASIC.MODULE_ID][0].FIELDS.HAS_CORP_QUAL.DEFAULT_VALUE || _.get(params, "IMG_DATA.HAS_CORP_QUAL"),
    MATCHING_RESULTS: _.get(params, "BIZ_DATA.PROPER_DATA.IS_MATCH"),
    IS_CHECK_REGISTER_FUND: _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS.REGISTER_FUND.isCheckCheckbox ? "1" : "0",
    OPEN_ACCT_TYPE: _this.$store.state.openAcctType
  };

  if (params.IS_AGENT === "0" || params.IS_AGENT === "1") {
    imgObj.IS_AGENT = params.IS_AGENT;
  } else {
    imgObj.IS_AGENT = _.get(params, "IMG_DATA.IS_AGENT");
  }
  return imgObj;
};


var QS420 = _.merge(_.cloneDeep(bizOrgOcr), _.cloneDeep(bizOrgImportantInfoNode), _.cloneDeep(bizZdInfoNode), _.cloneDeep(bizOrgAgentBasicInfoNode), _.cloneDeep(bizOrgOcrAgent), _.cloneDeep(bizOrgBasicInfoNode), _.cloneDeep(bizOtherLinkInfoNode), _.cloneDeep(bizOtherLegalInfoNode), _.cloneDeep(bizOtherAgentLinkInfoNode), _.cloneDeep(bizOtherPartnerInfoNode), _.cloneDeep(bizControlModuleInfoNode), _.cloneDeep(bizControlCustomModuleInfoNode), _.cloneDeep(bizControlBeneficiaryInfoNode), _.cloneDeep(bizOtherCreditInfoNode), _.cloneDeep(bizTaxCustInfoNode), _.cloneDeep(bizTaxContolInfoNode), _.cloneDeep(bizTrdAcctInfoNode), _.cloneDeep(bizAcctBsbInfoNode), _.cloneDeep(bizAcctAssetInfoNode), _.cloneDeep(bizAgentPhoneInfoNode), _.cloneDeep(bizPasswordInfoNode), {
  beforeLoadBiz: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_POSITION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.POSITION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.OTHER_INFO_PAGE.AGENT_LINK_MODULE[0].FIELDS.RELATION_PATION.FIELD_CONTROL = "1";
              _this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE[0].FIELDS.SHARE_RATIO.FIELD_CONTROL = "1";
              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CUST_NAME.VALID_TYPE = "length[0,256]";
              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CTRL_SHARE_RATIO.VALID_TYPE = "number[100,100]|max[8]";
              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.IS_FINANCIAL_INSTITUTION.FIELD_TYPE = "radio";
              _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.FIELD_TYPE = "radio";

              _this.groupDatasTpl.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CUST_NAME.VALID_TYPE = "length[0,256]";
              _this.groupDatasTpl.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.CTRL_SHARE_RATIO.VALID_TYPE = "number[100,100]|max[8]";
              _this.groupDatasTpl.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
              _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.IS_FINANCIAL_INSTITUTION.FIELD_TYPE = "radio";
              _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.FIELD_TYPE = "radio";

              _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].MODULE_CONTROL = "0";
              bizOrgOcr.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP_OCR.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP_OCR.SAVE_PATH });
              bizOrgImportantInfoNode.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH, savePath2: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH2, savePath3: GROUP_INFO.OCR_ORG.IMP.SAVE_PATH3 });
              bizZdInfoNode.init(_this, { groupId: GROUP_INFO.OCR_ORG.GROUP_ID, moduleId: GROUP_INFO.OCR_ORG.IMP_ZD.MODULE_ID, savePath: GROUP_INFO.OCR_ORG.IMP_ZD.SAVE_PATH, savePath2: GROUP_INFO.OCR_ORG.IMP_ZD.SAVE_PATH2 });
              bizOrgAgentBasicInfoNode.init(_this, { groupId: GROUP_INFO.OCR_AGENT.GROUP_ID, moduleId: GROUP_INFO.OCR_AGENT.AGENT.MODULE_ID, savePath: GROUP_INFO.OCR_AGENT.AGENT.SAVE_PATH });
              bizOrgOcrAgent.init(_this, { groupId: GROUP_INFO.OCR_AGENT.GROUP_ID, moduleId: GROUP_INFO.OCR_AGENT.AGENT_OCR.MODULE_ID, savePath: GROUP_INFO.OCR_AGENT.AGENT_OCR.SAVE_PATH });

              bizOrgBasicInfoNode.init(_this, { groupId: GROUP_INFO.ORG.GROUP_ID, moduleId: GROUP_INFO.ORG.BASIC.MODULE_ID, savePath: GROUP_INFO.ORG.BASIC.SAVE_PATH, savePath2: GROUP_INFO.ORG.BASIC.SAVE_PATH2, savePath3: GROUP_INFO.ORG.BASIC.SAVE_PATH3, savePath4: GROUP_INFO.ORG.BASIC.SAVE_PATH4, savePath5: GROUP_INFO.ORG.BASIC.SAVE_PATH5 });

              bizOtherLinkInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.LINK.MODULE_ID, savePath: GROUP_INFO.OTHER.LINK.SAVE_PATH, savePath2: GROUP_INFO.OTHER.LINK.SAVE_PATH2, savePath3: GROUP_INFO.OTHER.LINK.SAVE_PATH3 });
              bizOtherLegalInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.LEGAL.MODULE_ID, savePath: GROUP_INFO.OTHER.LEGAL.SAVE_PATH, savePath2: GROUP_INFO.OTHER.LEGAL.SAVE_PATH2 });
              bizOtherAgentLinkInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.AGENT_LINK.MODULE_ID, savePath: GROUP_INFO.OTHER.AGENT_LINK.SAVE_PATH });
              bizOtherPartnerInfoNode.init(_this, { groupId: GROUP_INFO.OTHER.GROUP_ID, moduleId: GROUP_INFO.OTHER.PARTNER.MODULE_ID, savePath: GROUP_INFO.OTHER.PARTNER.SAVE_PATH });

              bizControlModuleInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.CTRMODULE1.MODULE_ID, savePath: GROUP_INFO.CONTROLER.CTRMODULE1.SAVE_PATH });
              bizControlCustomModuleInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.CTRMODULE.MODULE_ID, savePath: GROUP_INFO.CONTROLER.CTRMODULE.SAVE_PATH });
              bizControlBeneficiaryInfoNode.init(_this, { groupId: GROUP_INFO.CONTROLER.GROUP_ID, moduleId: GROUP_INFO.CONTROLER.BENEFICIARY.MODULE_ID, savePath: GROUP_INFO.CONTROLER.BENEFICIARY.SAVE_PATH, savePath2: GROUP_INFO.CONTROLER.BENEFICIARY.SAVE_PATH2 });

              bizOtherCreditInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CREDIT_INFO.MODULE_ID, savePath: GROUP_INFO.TAX.CREDIT_INFO.SAVE_PATH });

              bizTaxCustInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CUST_INFO.MODULE_ID, savePath: GROUP_INFO.TAX.CUST_INFO.SAVE_PATH });
              bizTaxContolInfoNode.init(_this, { groupId: GROUP_INFO.TAX.GROUP_ID, moduleId: GROUP_INFO.TAX.CONTROLER_TAX.MODULE_ID, savePath: GROUP_INFO.TAX.CONTROLER_TAX.SAVE_PATH });

              bizTrdAcctInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.TRDACCT_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.TRDACCT_INFO.SAVE_PATH });
              bizAcctBsbInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.BSB_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.BSB_INFO.SAVE_PATH, savePath2: GROUP_INFO.ACCT.BSB_INFO.SAVE_PATH2 });
              bizAcctAssetInfoNode.init(_this, { groupId: GROUP_INFO.ACCT.GROUP_ID, moduleId: GROUP_INFO.ACCT.ASSET_INFO.MODULE_ID, savePath: GROUP_INFO.ACCT.ASSET_INFO.SAVE_PATH, savePath2: GROUP_INFO.ACCT.ASSET_INFO.SAVE_PATH2 });

              bizAgentPhoneInfoNode.init(_this, { groupId: GROUP_INFO.PASSWORD.GROUP_ID, moduleId: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.MODULE_ID, savePath: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.SAVE_PATH, savePath2: GROUP_INFO.PASSWORD.AGENT_PHONE_INFO.SAVE_PATH2 });
              bizPasswordInfoNode.init(_this, { groupId: GROUP_INFO.PASSWORD.GROUP_ID, moduleId: GROUP_INFO.PASSWORD.PASSWORD_INFO.MODULE_ID, savePath: GROUP_INFO.PASSWORD.PASSWORD_INFO.SAVE_PATH, savePath2: GROUP_INFO.PASSWORD.PASSWORD_INFO.SAVE_PATH2 });

              _this.oppBusiData.hideFields = {};
              if (_this.apptStatus >= 4) {
                _this.oppBusiData.hasAppvTask1 = true;
              }
              return _context.abrupt("return", _Promise.all([oppService.getSysCommonParamsFromCacheObjs("EFFECT_ID_TYPE"), oppService.getSysCommonParamsFromCacheObjs("MECHANISM_PRO_INVESTORS_I")]).then(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    res0 = _ref3[0],
                    res1 = _ref3[1];

                _this.oppBusiData.EFFECT_ID_TYPE = res0.split(",");
                _this.oppBusiData.mechanismProInvestors = res1.split(",");
                _this.oppBusiData.isShowBeneficiaryTypeAlert = "0";
                return _Promise.all([].concat(_this.$blMethod.getPromiseArr(NODE_LIST, "beforeLoadBiz", _this, [_this]))).then(function (res) {
                  consoleLog("QS420befoload执行完成");
                }).catch(function (err) {
                  consoleError("初始化资料节点失败：", err);
                });
              }));

            case 41:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function beforeLoadBiz(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  afterLoadBiz: function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", _Promise.all([].concat(_this.$blMethod.getPromiseArr(NODE_LIST, "afterLoadBiz", _this, [_this]))).then(function (res) {
                consoleLog("QS420afterLoadBiz执行完成");

                if (!_.isEmpty(_.get(_this.historyData, "DETAIL_DATA.CSDC_INFO", {}))) {
                  _this.$blMethod.backFillCsdcInfo(_this, _this.historyData.DETAIL_DATA.CSDC_INFO, true);
                }

                if (!_.isEmpty(_.get(_this.historyData, "DETAIL_DATA.COMPANY_BASIC_INFO", {}))) {
                  _this.$blMethod.backFillCompanyInfo(_this, _this.historyData.DETAIL_DATA.COMPANY_BASIC_INFO);
                }

                if (!_.isEmpty(_.get(_this.historyData, "BIZ_DATA.OPENTMPL_INFO", {}))) {
                  _this.oppBusiData.OPENTMPL_INFO = _.get(_this.historyData, "BIZ_DATA.OPENTMPL_INFO", {});
                }
              }).catch(function (err) {
                consoleError("初始化资料节点qs420afterloadbiz失败：", err);
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function afterLoadBiz(_x2) {
      return _ref4.apply(this, arguments);
    };
  }(),
  pageActivated: function pageActivated(_this) {
    _this.oppBusiData.validateResArr = [];
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "pageActivated", _this, [_this], func))).then(function (res) {});
  },
  validate: function validate(_this) {
    _this.oppBusiData.validateResArr = [];
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "validate", _this, [_this], func))).then(function (res) {
      if (res.includes(false)) {
        return false;
      }
      if (_this.oppBusiData.validateResArr.length) {
        if (_this.oppBusiData.validateResArr[0].alertType == "confirm") {
          return new _Promise(function (resolve, reject) {
            _this.confirm({
              messageText: _this.oppBusiData.validateResArr[0].messageText,
              cancelButtonText: "修改",
              confirmButtonText: "确定",
              confirmedAction: function confirmedAction() {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                resolve(true);
              },
              canceledAction: function canceledAction() {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                resolve(false);
              }
            });
          }).then(function (res) {
            return res;
          });
        } else if (_this.oppBusiData.validateResArr[0].alertType == "alert") {
          _this.alert(_this.oppBusiData.validateResArr[0].messageText);
          return false;
        }
        return false;
      }
      return true;
    }).catch(function (err) {
      console.error("校验失败", err.toString());
      return false;
    });
  },
  preValidate: function preValidate(_this) {
    _this.$blMethod.invoke(NODE_LIST, "preValidate", _this, [_this]);
  },
  "beforeSave": function beforeSave(_this, params, baseData) {
    if (_.isEmpty(_this.moduleId)) {
      return;
    }
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getModuleId && _this.moduleId.includes(obj.getModuleId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "beforeSave", _this, [_this, params, baseData], func))).then(_asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      var userInfo, customerInfo, imgData, NEW_CUST_CODE, dataUserCode;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              userInfo = _this.$storage.getJsonSession(_this.$definecfg.USER_INFO);
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);
              imgData = getImgBusiData(_this, params);

              params.IMG_DATA = _Object$assign({}, params.IMG_DATA, imgData);
              params.BIZ_DATA.NET_INFO = {
                NET_SERVICE: "0",
                NET_PASSWORD: ""
              };
              params.BIZ_DATA.ORG_CODE = customerInfo.INT_ORG;
              params.BUSI_FLAG = "1";
              if (params.BIZ_DATA && params.BIZ_DATA.BASE_INFO && params.BIZ_DATA.BASE_INFO.SZORG_TYPE) {
                if (_this.oppBusiData.mechanismProInvestors.indexOf(params.BIZ_DATA.BASE_INFO.SZORG_TYPE) > -1) {
                  params.BUSI_FLAG = "2";
                }
              }
              NEW_CUST_CODE = _.get(params, "BIZ_DATA.NEW_CUST_CODE", "");

              if (NEW_CUST_CODE) {
                _context3.next = 14;
                break;
              }

              dataUserCode = { ORG_CODE: userInfo.ORG_CODE };
              return _context3.abrupt("return", _this.$syscfg.K_Request("F0000020", dataUserCode).then(function (res) {
                NEW_CUST_CODE = _.get(res, "Data[0].USER_CODE", "");
                _.set(params, "BIZ_DATA.NEW_CUST_CODE", NEW_CUST_CODE);
                customerInfo.CUST_CODE = NEW_CUST_CODE;
                customerInfo.NEW_CUST_CODE = NEW_CUST_CODE;
                _this.$storage.setSession(_this.$definecfg.CUSTOMER_INFO, customerInfo);
              }));

            case 14:
              customerInfo.CUST_CODE = NEW_CUST_CODE;
              _this.$storage.setSession(_this.$definecfg.CUSTOMER_INFO, customerInfo);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    })));
  },
  "afterSave": function afterSave(_this, params) {
    if (_.isEmpty(_this.moduleId)) {
      return;
    }
    var func = function func(_this, nodeList) {
      return _.filter(nodeList, function (obj) {
        return obj.getGroupId && _this.groupId.includes(obj.getGroupId());
      });
    };
    return _Promise.all([].concat(_this.$blMethod.getPromiseArrWithFilter(NODE_LIST, "afterSave", _this, [_this], func))).then(function (res) {
      if (_.includes(res, false)) {
        return false;
      }
      return true;
    }).catch(function (err) {
      if (err === "preventNextStep") {
        throw "preventNextStep";
      }
      console.error("校验失败", err.toString());
      throw "preventNextStep";
    });
  },
  CHECK_OCR_ITEM: function CHECK_OCR_ITEM(_this, field, fieldData) {
    consoleLog("拍照字段关联逻辑触发，识别到的客户数据为", field.cardData);
    var cardData = field.cardData;
    _this.oppBusiData.isLoadData = true;
    if (field.MODULE_ID == "IMPORTANT_MODULE_OCR" && !_.isEmpty(cardData)) {
      (function () {
        _this.$blMethod.diabledFieldCheck(_this);

        var orgData = _this.groupDatas[field.GROUP_ID][field.MODULE_ID.split("_OCR")[0]][0].FIELDS;
        orgData = _Object$assign({}, orgData, _this.groupDatas.ORG_INFO_PAGE.BASIC_MODULE[0].FIELDS);

        var _loop = function _loop(fk) {
          if (fk in orgData && orgData[fk]) {
            if (cardData[fk] && cardData[fk].replaceAll("*", "") && orgData[fk].DATA_SOURCE != 3) {
              orgData[fk].DEFAULT_VALUE = cardData[fk];
            }

            _this.$nextTick(function () {
              if (cardData[fk] && orgData[fk].DATA_SOURCE != 3) {
                orgData[fk].DATA_SOURCE = 1;
              }
            });
          }
        };

        for (var fk in cardData) {
          _loop(fk);
        }
        setTimeout(function () {
          _this.$blMethod.enableFieldCheck(_this);
          _this.busiLogic.GET_ZZ_DATA(_this, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS);
          _this.busiLogic.CHECK_ID_CODE(_this, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE, _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS);
        }, 3000);
      })();
    } else if (field.MODULE_ID == "AGENT_MODULE_OCR" && !_.isEmpty(cardData)) {
      (function () {
        _this.$blMethod.diabledFieldCheck(_this);
        var agentData = _this.groupDatas[field.GROUP_ID][field.MODULE_ID.split("_OCR")[0]][0].FIELDS;
        if (cardData.address) {
          cardData.AGENT_USER_FNAME = cardData.USER_FNAME || "";

          cardData.AGENT_ID_TYPE = "00";

          cardData.AGENT_ID_CODE = cardData.ID_CODE || "";

          cardData.AGENT_BIRTHDAY = cardData.BIRTHDAY;

          cardData.AGENT_SEX = cardData.SEX;
        }
        if (cardData.validity) {
          cardData.AGENT_ID_EXP_DATE = cardData.ID_EXP_DATE || "";
        }

        var _loop2 = function _loop2(fk) {
          if (fk in agentData && agentData[fk]) {
            if (cardData[fk] && cardData[fk].replaceAll("*", "") && agentData[fk].DATA_SOURCE != 3) {
              agentData[fk].DEFAULT_VALUE = cardData[fk];
            }
            _this.$nextTick(function () {
              if (cardData[fk] && agentData[fk].DATA_SOURCE != 3) {
                agentData[fk].DATA_SOURCE = 1;
              }
            });
          }
        };

        for (var fk in cardData) {
          _loop2(fk);
        }
        setTimeout(function () {
          _this.$blMethod.enableFieldCheck(_this);
        }, 3000);
      })();
    }
    setTimeout(function () {
      _this.oppBusiData.isLoadData = false;
      field.cardData = {};
    }, 500);
  },
  CHECK_MOBILE_TEL__CLICK: function CHECK_MOBILE_TEL__CLICK(_this, field, fieldData) {
    if (field.MODULE_ID == "AGENT_LINK_MODULE" && fieldData.MOBILE_TEL.DEFAULT_VALUE && fieldData.MOBILE_TEL.correct) {
      if (!field.DEFAULT_VALUE) {
        alert("请填写手机号！");
        return;
      }
      var APPT_SN = _this.$storage.getSession(_this.$definecfg.APPT_SN) || "";
      _this.loading = true;
      _this.loadingText = "正在发送...";
      return smsService.sendSmsMsg({
        APPT_SN: APPT_SN,
        type: 2,
        phoneNo: field.DEFAULT_VALUE,
        BUSI_CODE: _this.busiCode,
        USER_TYPE: _this.userType,
        isCust: "1" }).then(function (resultObj) {
        var remainTime = field.remainTime || 300;
        if (!resultObj.time) {
          var that = _this;
          _this.alert({
            messageText: resultObj && resultObj.code ? resultObj.code : "信息已发送到：【" + field.DEFAULT_VALUE + "】，请先进行风险测评后再继续录入！",
            confirmedAction: function () {
              var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this2);
              }));

              return function confirmedAction() {
                return _ref6.apply(this, arguments);
              };
            }(),
            confirmButtonText: "关闭"
          });
        } else {
          remainTime = resultObj.time;
          _this.alert("获取验证码失败:" + resultObj.msg);
        }
        _this.$set(field, "remainTime", remainTime);

        _this.$set(field, "codeStatus", "codeStart");
        _this.oppBusiData.isAssignValidCodeTimeout = true;
        setTimeout(function () {
          _this.oppBusiData.isAssignValidCodeTimeout = false;
          _this.$set(field, "codeStatus", "codeEnd");
        }, remainTime * 1000);
      });
    }
  },
  addModuleFinished: function addModuleFinished(_this, moduleObj) {
    if (moduleObj.MODULE_ID == "CREDIT_INFO") {
      tools.addCreditModule(_this, moduleObj);
    }
    if (_this.groupId === "CONTROLER_INFO_PAGE" && moduleObj.MODULE_ID === "BENEFICIARY_MODULE") {
      _this2.default.moduleFinishedConfig(_this, moduleObj);
    }
  },
  deleteModuleFinished: function deleteModuleFinished(_this, modules) {
    if (modules.MODULE_ID == "CREDIT_INFO") {
      tools.addCreditModule(_this, modules, true);
    }
    if (modules.MODULE_ID == "PARTNER_MODULE") {
      _.set(modules, "MAX_LENGTH", 50);
    }
  },
  moduleFinishedConfig: function moduleFinishedConfig(_this, moduleObj) {
    var fields = moduleObj.FIELDS;
    fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_TYPE = "radio");
    fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1");
    fields.BENEFICIARY_TEL.VALID_TYPE = "mobileortel";
    fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME, function (item) {
      return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
    });
    fields.SHARE_RATIO.unitText = "%";
    _.set(fields, "NATION.FIELD_TYPE", "selector");

    fields.IS_UPLOAD_IMG.DEFAULT_VALUE = "0";
  }
});

export default QS420;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/QS420.js
// module id = 279
// module chunks = 2